import { useStore } from '@stores';
import { IPosTerminal } from '@models';
import { useEffect } from 'react';

export const usePaymentTerminal = (): IPosTerminal => {
  const { paymentStore } = useStore();
  useEffect(() => {
    paymentStore.checkTerminalStatus();

    return () => {
      paymentStore.clearTerminalStatus();
    };
  }, [paymentStore]);

  return {
    isTerminalEnabled: paymentStore.isTerminalEnabled,
    loading: paymentStore.loading,
    checkTerminalStatus: paymentStore.checkTerminalStatus,
  };
};